import { render, staticRenderFns } from "./CreateTeacher.vue?vue&type=template&id=3b69f801&scoped=true&"
import script from "./CreateTeacher.vue?vue&type=script&lang=js&"
export * from "./CreateTeacher.vue?vue&type=script&lang=js&"
import style0 from "./CreateTeacher.vue?vue&type=style&index=0&id=3b69f801&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b69f801",
  null
  
)

export default component.exports